<template>
  <div class="control-group" role="group">
    <button
      v-for="item in items"
      :key="item"
      :data-value="item"
      :class="{ 'control-group__item--active': item === lazyValue }"
      type="button"
      class="control-group__item text-legend text--primary"
      @click="updateLazyValue"
    >
      {{ item }}
    </button>
  </div>
</template>

<script>
export default {
  name: 'SelectGroupFilter',
  props: {
    items: {
      type: Array,
      required: true,
    },
    value: null,
  },
  data() {
    return {
      lazyValue: this.value,
    };
  },
  methods: {
    updateLazyValue(e) {
      // get selected value
      const { value } = e.target.dataset;

      // update value
      this.lazyValue = value;
      // emit value
      this.$emit('input', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.control-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;

  > .control-group__item {
    flex: 1 0 auto;
    background-color: transparent;
    border: 1px solid #005EB8;
    padding: 11px 0;
    margin-left: -1px;

    &:first-child {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }

    &:last-child {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }

    // states
    &:hover {
      background-color: #005EB8;
      border: 1px solid #005EB8;
      color: #fff;
    }

    &:focus {
      background-color: #005EB8;
      border: 1px solid #005EB8;
      color: #fff;
    }

    &--active {
      background-color: #005EB8;
      color: #fff;
    }

    // media queries
    @media #{map-get($media-breakpoints, 'mobile')} {
      flex-basis: 100%;
      margin-left: 0;
      margin-top: -1px;

      &:first-child {
        border-bottom-left-radius: 0;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
      }

      &:last-child {
        border-top-right-radius: 0;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
      }
    }
  }
}
</style>
